import { FormLabel, Select } from '@chakra-ui/react';
import cacheData from 'memory-cache';
import React, { useState } from 'react';

import currencies from '../../constants/currencylist.json';

export const CurrencySelectExample = () => {
  const [currency, setCurrency] = useState('DKK');
  // cacheData.put('currency', 'USD');
  const handleCurrencyChange = (event) => {
    const { value } = event.target;
    cacheData.put('currency', value);
    setCurrency(value);
  };
  return (
    <div style={{ width: '300px', display: 'flex', marginRight: '10px' }}>
      <FormLabel style={{ textAlign: 'center', alignContent: 'center' }}>Currency</FormLabel>
      <Select value={currency} errorBorderColor='#FF8855' onChange={handleCurrencyChange}>
        {Object.keys(currencies).map((currency, index) => (
          <option key={index} value={currency}>
            {currency} - {currencies[currency].name}
          </option>
        ))}
      </Select>
    </div>
  );
};
